import React from 'react';
import Button from '@sinclair-digital/sbg-storyline-components/src/components/Button';
import Dialog from '@sinclair-digital/sbg-storyline-components/src/components/Dialog2';
import styles from './SessionTimeoutModal.css';

interface SessionTimeoutModalProps {
    timeLeft: string;
    onClose: () => any;
}

const SessionTimeoutModal = ({onClose, timeLeft}: SessionTimeoutModalProps) => (
    <Dialog
        heading="Session Timeout"
        onClose={onClose}
        isOpen={true}
        footer={<Button displayType="primary" onClick={onClose}>dismiss</Button>}
        footerClass={styles.footer}
        width="800"
        height="450"
    >
        <p>
            Due to enhanced security measure, Storyline now limits the amount of time a user can be logged in.
            To continue with your session, please&nbsp;
            <strong>save your current work and refresh the page.</strong>&nbsp;
            If you do not act, you will be logged off and any unsaved changes will be lost.
        </p>
        <p>The system will logout in:</p>
        <time className={styles.timeLeft}>{timeLeft}</time>
    </Dialog>
);

export default SessionTimeoutModal;
